<template lang="pug">
td.table-data-base
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * tdタグ
 */
@Component
export default class TableDataBase extends Vue {}
</script>

<style lang="stylus" scoped></style>
